<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-if="requireBtn" v-slot:activator="{ on, attrs }">
			<v-btn v-if="!icon" :text="text" :color="color()" class="ml-2" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-pencil</v-icon>
				機械編集
			</v-btn>
			<v-btn v-else icon :text="text" :color="color()" class="ml-2" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-pencil</v-icon>
			</v-btn>
		</template>

		<v-card tile>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">機械編集</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<ValidationError :errors="errors" />
			<v-form ref="form" v-model="valid" class="pa-2">
				<v-text-field
					label="機械名"
					v-model="machine.name"
					:rules="[rules.required]"
					class="mt-4"
					dense
					outlined
				/>
				<v-select
					v-if="!machine_type"
					label="在庫"
					v-model="machine.machine_type"
					:rules="[rules.required]"
					:items="machineTypes"
					:item-value="item.id"
					:item-text="item.name"
					class="mt-4"
					dense
					outlined
				/>
				<v-textarea label="備考" v-model="machine.memo" class="mt-4" dense outlined />
			</v-form>
			<v-row no-gutters justify="center">
				<v-btn color="secondary" @click="submitForm" :disabled="!valid">
					<v-icon class="mr-2">mdi-pencil</v-icon>
					編集する
				</v-btn>
			</v-row>
			<v-divider class="my-4" />
			<v-row no-gutters class="pb-2" justify="center">
				<TemplateDeleteDialog
					:openBtnColor="'red'"
					:openBtnDesign="['dark']"
					confirm
					:url="'/erp/v1/machines/' + machine.id"
					@success-delete="deleteMachine($event)"
				>
					<template v-slot:text>
						削除すると元に戻すことはできません。<br />
						本当によろしいですか。
						<template v-if="machine.machine_type == 'rubber_kneading'">
							<br />
							<span class="red--text"
								>※1 現在完了していないゴム加工データは、機械未設定となります。</span
							>
						</template>
					</template>
				</TemplateDeleteDialog>
			</v-row>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import rules from "../../../helper/rules"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import ValidationError from "../../shared/ValidationError.vue"
import TemplateDeleteDialog from "../../shared/TemplateDeleteDialog.vue"

export default {
	props: {
		text: Boolean,
		btnColor: {
			type: String,
			default: null,
		},
		// icon: trueの場合、アイコンボタンになる
		icon: {
			type: Boolean,
			default: false,
		},
		// machine_typeがある場合、機械タイプは変更できない
		machine_type: {
			type: String,
			required: false,
		},
		machine_types: {
			type: Array,
			required: false,
			default: () => [],
		},
		// requiredFetch: trueの場合、idが必須
		// requiredFetch: falseの場合、machine_typesが必須
		requiredFetch: {
			type: Boolean,
			required: false,
			default: false,
		},
		id: {
			type: Number,
			required: false,
			default: null,
		},
		machine_data: {
			type: Object,
			required: false,
			default: () => {},
		},
		requireBtn: {
			type: Boolean,
			required: false,
			default: false,
		},
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	components: {
		ValidationError,
		TemplateDeleteDialog,
	},
	data() {
		return {
			machine: {
				name: null,
				machine_type: null,
				memo: null,
			},
			machineTypes: [],
			valid: false,
			errors: [],
			rules: rules,
		}
	},
	mounted() {
		if (this.machine_types.length) {
			this.machineTypes = this.machine_types
		}
		if (this.machine_data) {
			this.machine = this.machine_data
		}
		if (this.machine_type) {
			this.machine.machine_type = this.machine_type
		}
		if (this.requiredFetch) {
			this.getMachine()
		}
	},
	methods: {
		getMachineTypes() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/machines/${this.id}/edit`
			axios
				.get(url, { headers })
				.then((res) => {
					this.machineTypes = res.data.machine_types
					this.machine = res.data.machine
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		submitForm() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/machines/${this.machine.id}`
			axios
				.put(url, { machine: this.machine }, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "機械を編集しました。",
					})
					this.$emit("update-machine", res.data)
					this.$refs.form.reset()
					this.showDialog = false
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
				})
		},
		deleteMachine() {
			this.showDialog = false
			this.$emit("delete-machine", this.machine)
		},
		color() {
			if (this.btnColor) {
				return this.btnColor
			} else if (this.text) {
				return "white"
			} else {
				return "secondary"
			}
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(val) {
				this.$emit("update:dialog", val)
			},
		},
	},
	watch: {
		machine_data(newVal, _) {
			this.machine = newVal
		},
		deep: true,
	},
}
</script>


<style lang="scss" scoped>
.products {
	.row {
		&:not(:first-child) {
			border-top: 1px solid whitesmoke;
		}
	}
}
</style>